import React from 'react';
import {
  TouchableOpacity,
  Text,
  StyleSheet,
  View,
  ActivityIndicator,
  ColorValue,
} from 'react-native';
import T from './T';
import BTLinearGradient from './BTLinearGradient';

interface BTButtonProps {
  title: string;
  onPress: () => void;
  onLongPress?: () => void;
  loading?: boolean;
  disabled?: boolean;
  style?: object;
  buttonStyle?: object;
  textStyle?: object;
  color?: ColorValue;
}

const BTButton = ({
  title,
  onPress,
  onLongPress,
  loading = false,
  disabled = false,
  style = {},
  buttonStyle = {},
  textStyle = {},
  color,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      onLongPress={onLongPress}
      disabled={disabled || loading}
      style={[styles.touchable, style]}>
      <BTLinearGradient
        colors={
          disabled ? ['#A9A9A9', '#A9A9A9'] : ['#4c669f', '#3b5998', '#192f6a']
        }
        style={[styles.button, buttonStyle]}>
        {loading ? (
          <ActivityIndicator size="small" color="#fff" style={styles.spinner} />
        ) : (
          <Text style={[styles.text, textStyle]}><T>{title}</T></Text>
        )}
      </BTLinearGradient>
    </TouchableOpacity>
  );
};

BTButton.displayName = 'BTButton';

const styles = StyleSheet.create({
  touchable: {
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    minHeight: 50,
    marginTop: 10,
    marginBottom: 10,
  },
  button: {
    paddingVertical: 6,
    paddingHorizontal: 10,
    minHeight: 50,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  text: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '600',
  },
  contentContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  spinner: {
    marginRight: 8,
  },
});

export default BTButton;

